module.exports = __webpack_public_path__ + "img/proof-nyomtatas-mintakeszites.9996540c.jpg";